module.exports = __webpack_public_path__ + "static/new-2-c9ce12af8fd14fd4646da12133fbb6c0.svg";